import { Stack } from '@mui/material';
import { FC } from 'react';

const NoResultsOverlay: FC = () => {
  return (
    <Stack direction="row" padding={1} pt={2}>
      There were no results found that match your search criteria.
    </Stack>
  );
};

export default NoResultsOverlay;
